import { create } from 'zustand';

interface KycStore {
  progress: number;
  setProgress: (value: number) => void;
}

export const useKycStore = create<KycStore>((set) => ({
  progress: 0,

  setProgress: (value: number) => set({ progress: value }),
}));